// ============================================================
// BUTTONS PAYMENTS V1
// ============================================================
$(document).on('click', '.btn-add-minimum', function(e) {
    e.preventDefault();
    var $btn = $(this);
    // Seguridad: si está deshabilitado, no hacemos nada
    if ($btn.prop('disabled')) {
        return;
    }
    if ($btn.data('processing')) {
        return;
    }
    $btn.data('processing', true);
    var originalText = $btn.text();
    $btn.text('Añadiendo...').prop('disabled', true);
    var $form = $btn.closest('form');
    var variantId = $form.find('input[name="id"]').val();
    var quantity = parseInt($form.find('input[name="quantity"]').val(), 10) || 1;
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
            id: variantId,
            quantity: quantity
        })
    }).then(function(resp) {
        if (!resp.ok) {
            throw resp;
        }
        return resp.json();
    }).then(function(item) {
        $btn.text('Añadido ✓');
        setTimeout(function() {
            window.location.reload();
        }, 600);
    }).catch(function(err) {
        console.error('Add to cart error:', err);
        $btn.text('Error — reintentar').prop('disabled', false).removeClass('qty-button-disabled');
        setTimeout(function() {
            $btn.text(originalText).data('processing', false);
        }, 2000);
    });
});
// ============================================================
// VALIDACIÓN DE CANTIDADES
// ============================================================
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.product-form').forEach(function(form) {
        const visibleQty = form.querySelector('.qty-visible');
        const hiddenQty = form.querySelector('.real-quantity');
        // Si el formulario no tiene nuestro selector,
        // simplemente lo ignoramos.
        if (!visibleQty || !hiddenQty) {
            return;
        }
        // ----------------------------------------------------
        // CONTROL DEL ESTADO DEL BOTÓN
        // ----------------------------------------------------
        function updateAddButtonState(valid) {
            const addButton = form.querySelector('.btn-add-minimum');
            if (!addButton) {
                return;
            }
            if (valid) {
                addButton.disabled = false;
                addButton.classList.remove('qty-button-disabled');
                addButton.removeAttribute('aria-disabled');
            } else {
                addButton.disabled = true;
                addButton.classList.add('qty-button-disabled');
                addButton.setAttribute('aria-disabled', 'true');
            }
        }
        // ----------------------------------------------------
        // CREAR MENSAJE DE ERROR
        // ----------------------------------------------------
        function getErrorElement() {
            let error = form.querySelector('.qty-validation-error');
            if (!error) {
                error = document.createElement('div');
                error.className = 'qty-validation-error';
                error.style.cssText = `
              margin-top: 8px;
              padding: 8px 10px;

              border: 1px solid #e0a800;
              border-radius: 4px;

              background: #fff8e1;
              color: #856404;

              font-size: 13px;
              line-height: 1.4;

              display: none;

              width: 100%;
              box-sizing: border-box;
            `;
                const wrapper = visibleQty.closest('.minimum-quantity-wrapper, .minimum-search-actions');
                if (wrapper) {
                    wrapper.insertAdjacentElement('afterend', error);
                } else {
                    visibleQty.parentElement.appendChild(error);
                }
            }
            return error;
        }
        // ----------------------------------------------------
        // MOSTRAR ERROR
        // ----------------------------------------------------
        function showQuantityError(message) {
            const error = getErrorElement();
            error.textContent = '⚠ ' + message;
            error.style.display = 'block';
            visibleQty.classList.add('qty-input-error');
            visibleQty.dataset.qtyInvalid = 'true';
        }
        // ----------------------------------------------------
        // OCULTAR ERROR
        // ----------------------------------------------------
        function clearQuantityError() {
            const error = form.querySelector('.qty-validation-error');
            if (error) {
                error.style.display = 'none';
            }
            visibleQty.classList.remove('qty-input-error');
            delete visibleQty.dataset.qtyInvalid;
        }
        // ----------------------------------------------------
        // VALIDAR CANTIDAD
        // ----------------------------------------------------
        function validateQuantity() {
            const minimumQty = parseInt(visibleQty.dataset.minimum || visibleQty.min || 1, 10);
            const maximumQty = parseInt(visibleQty.dataset.maximum || visibleQty.max || 999999, 10);

            let qty = parseInt(visibleQty.value, 10);
            // ----------------------------------------------
            // CANTIDAD VACÍA / INVÁLIDA
            // ----------------------------------------------
            if (isNaN(qty) || qty <= 0) {
                showQuantityError('Ingresa una cantidad válida.');
                updateAddButtonState(false);
                return false;
            }
            // ----------------------------------------------
            // MENOR AL MÍNIMO
            // ----------------------------------------------
            if (qty < minimumQty) {
                showQuantityError('La cantidad mínima de compra es ' + minimumQty.toLocaleString('es-CL') + ' unidades.');
                updateAddButtonState(false);
                return false;
            }
            // ----------------------------------------------
            // MAYOR AL STOCK
            // ----------------------------------------------
            if (qty > maximumQty) {
                visibleQty.value = maximumQty;
                hiddenQty.value = maximumQty;
                clearQuantityError();
                updateAddButtonState(true);
                return true;
            }
            // ----------------------------------------------
            // CANTIDAD VÁLIDA
            // ----------------------------------------------
            clearQuantityError();
            hiddenQty.value = qty;
            updateAddButtonState(true);
            return true;
        }
        // ----------------------------------------------------
        // SINCRONIZACIÓN INICIAL
        // ----------------------------------------------------
        hiddenQty.value = visibleQty.value;
        // ----------------------------------------------------
        // CHANGE
        // ----------------------------------------------------
        visibleQty.addEventListener('change', function() {
            validateQuantity();
        });
        // ----------------------------------------------------
        // INPUT
        // ----------------------------------------------------
        visibleQty.addEventListener('input', function() {
            const minimumQty = parseInt(visibleQty.dataset.minimum || visibleQty.min || 1, 10);
            const maximumQty = parseInt(visibleQty.dataset.maximum || visibleQty.max || 999999, 10);
            
            let qty = parseInt(this.value, 10);
            // Campo vacío:
            // no hacemos nada todavía.
            if (isNaN(qty)) {
                updateAddButtonState(false);
                return;
            }
            // ----------------------------------------------
            // SUPERIOR AL STOCK
            // ----------------------------------------------
            if (qty > maximumQty) {
                qty = maximumQty;
                this.value = qty;
            }
            // ----------------------------------------------
            // MENOR AL MÍNIMO
            // ----------------------------------------------
            if (qty < minimumQty) {
                showQuantityError('La cantidad mínima de compra es ' + minimumQty.toLocaleString('es-CL') + ' unidades.');
                updateAddButtonState(false);
                return;
            }
            // ----------------------------------------------
            // CANTIDAD VÁLIDA
            // ----------------------------------------------
            clearQuantityError();
            hiddenQty.value = qty;
            updateAddButtonState(true);
        });
        // ----------------------------------------------------
        // SUBMIT
        // ----------------------------------------------------
        form.addEventListener('submit', function(event) {
            const valid = validateQuantity();
            if (!valid) {
                event.preventDefault();
                return false;
            }
            hiddenQty.value = visibleQty.value;
        });
        // ----------------------------------------------------
        // ESTADO INICIAL
        // ----------------------------------------------------
        validateQuantity();
    });
});
// ============================================================
// BOTONES + Y -
// ============================================================
document.addEventListener('click', function(e) {
    // ========================================================
    // PLUS
    // ========================================================
    const plusButton = e.target.closest('.qty-plus');
    if (plusButton) {
        const form = plusButton.closest('.product-form');
        if (!form) {
            return;
        }
        const visibleQty = form.querySelector('.qty-visible');
        const hiddenQty = form.querySelector('.real-quantity');
        if (!visibleQty || !hiddenQty) {
            return;
        }
        const maximumQty = parseInt(visibleQty.dataset.maximum || visibleQty.max || 999999, 10);
        let qty = parseInt(visibleQty.value, 10) || 0;
        if (qty < maximumQty) {
            qty++;
        }
        visibleQty.value = qty;
        hiddenQty.value = qty;
        visibleQty.dispatchEvent(new Event('input', { bubbles: true }));
        visibleQty.dispatchEvent(new Event('change', { bubbles: true }));
        // ----------------------------------------------
        // Si alcanzamos el mínimo, quitamos el error.
        // ----------------------------------------------
        const minimumQty = parseInt(visibleQty.dataset.minimum || visibleQty.min || 1, 10);
        if (qty >= minimumQty) {
            const error = form.querySelector('.qty-validation-error');
            if (error) {
                error.style.display = 'none';
            }
            visibleQty.classList.remove('qty-input-error');
            delete visibleQty.dataset.qtyInvalid;
            // Habilitar botón
            const addButton = form.querySelector('.btn-add-minimum');
            if (addButton) {
                addButton.disabled = false;
                addButton.classList.remove('qty-button-disabled');
                addButton.removeAttribute('aria-disabled');
            }
        }
    }
    // ========================================================
    // MINUS
    // ========================================================
    const minusButton = e.target.closest('.qty-minus');
    if (minusButton) {
        const form = minusButton.closest('.product-form');
        if (!form) {
            return;
        }
        const visibleQty = form.querySelector('.qty-visible');
        const hiddenQty = form.querySelector('.real-quantity');
        if (!visibleQty || !hiddenQty) {
            return;
        }
        const minimumQty = parseInt(visibleQty.dataset.minimum || visibleQty.min || 1, 10);
        const cartQty = parseInt(visibleQty.dataset.cartQuantity || 0, 10);
        let qty = parseInt(visibleQty.value, 10);
        if (isNaN(qty)) {
            qty = cartQty > 0 ? 1 : minimumQty;
        }
        qty = Math.max(minimumQty, qty - 1);
        visibleQty.value = qty;
        hiddenQty.value = qty;
        visibleQty.dispatchEvent(new Event('input', { bubbles: true }));
        visibleQty.dispatchEvent(new Event('change', { bubbles: true }));
        // ----------------------------------------------
        // Limpiar error si corresponde
        // ----------------------------------------------
        if (qty >= minimumQty) {
            const error = form.querySelector('.qty-validation-error');
            if (error) {
                error.style.display = 'none';
            }
            visibleQty.classList.remove('qty-input-error');
            delete visibleQty.dataset.qtyInvalid;
            // Habilitar botón
            const addButton = form.querySelector('.btn-add-minimum');
            if (addButton) {
                addButton.disabled = false;
                addButton.classList.remove('qty-button-disabled');
                addButton.removeAttribute('aria-disabled');
            }
        }
    }
});
// ============================================================
// ESTILOS DE VALIDACIÓN
// ============================================================
(function() {
    const style = document.createElement('style');
    style.textContent = `
    /*
     * Input con cantidad inválida
     */
    .qty-input-error {
      border-color: inherit !important;
      box-shadow:none;
    }
    /*
     * Botón Añadir al carro deshabilitado
     */
    .btn-add-minimum.qty-button-disabled,
    .btn-add-minimum:disabled {
      opacity: 0.45 !important;
      cursor: not-allowed !important;
      pointer-events: none !important;
      filter: grayscale(100%);
      box-shadow: none !important;
      transform: none !important;
    }
  `;
    document.head.appendChild(style);
})();
// ============================================================
// ENTER EN INPUT DE CANTIDAD
// ============================================================
document.addEventListener('keydown', function(event) {
    // Solo inputs de cantidad
    if (!event.target.matches('.qty_inpt2')) {
        return;
    }
    // Solo Enter
    if (event.key !== 'Enter') {
        return;
    }
    event.preventDefault();
    const input = event.target;
    const form = input.closest('form');
    if (!form) {
        return;
    }
    const minimumQty = parseInt(input.dataset.minimum || input.min || 1, 10);
    const maximumQty = parseInt(input.dataset.maximum || input.max || 999999, 10);
    let qty = parseInt(input.value, 10);
    // Cantidad inválida
    if (isNaN(qty) || qty <= 0) {
        const error = form.querySelector('.qty-validation-error');
        if (error) {
            error.textContent = '⚠ Ingresa una cantidad válida.';
            error.style.display = 'block';
        }
        input.classList.add('qty-input-error');
        return;
    }
    // Menor al mínimo
    if (qty < minimumQty) {
        const error = form.querySelector('.qty-validation-error');
        if (error) {
            error.textContent = '⚠ La cantidad mínima de compra es ' + minimumQty.toLocaleString('es-CL') + ' unidades.';
            error.style.display = 'block';
        }
        input.classList.add('qty-input-error');
        return;
    }
    // Mayor al máximo
    if (qty > maximumQty) {
        input.value = maximumQty;
        qty = maximumQty;
    }
    // Sincronizar el hidden
    const hiddenQty = form.querySelector('.real-quantity');
    if (hiddenQty) {
        hiddenQty.value = qty;
    }
    // Limpiar error
    const error = form.querySelector('.qty-validation-error');
    if (error) {
        error.style.display = 'none';
    }
    input.classList.remove('qty-input-error');
    // Buscar el botón Añadir
    const addButton = form.querySelector('.btn-add-minimum');
    if (!addButton || addButton.disabled) {
        return;
    }

    // Ejecutar exactamente la misma acción
    // que al presionar "Añadir al carro"
    addButton.click();
});